import {NgModule}         from '@angular/core';
import {PlatformNamePipe} from './pipes/platform-name.pipe';
import {MomentPipe}       from './pipes/moment.pipe';

@NgModule({
   declarations: [
       PlatformNamePipe,
       MomentPipe
   ],
    exports: [
        PlatformNamePipe,
        MomentPipe
    ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/shared.module.ts